import { render, staticRenderFns } from "./OtherContent.vue?vue&type=template&id=20e5f21b&scoped=true&"
import script from "./OtherContent.vue?vue&type=script&lang=js&"
export * from "./OtherContent.vue?vue&type=script&lang=js&"
import style0 from "./OtherContent.vue?vue&type=style&index=0&id=20e5f21b&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e5f21b",
  null
  
)

export default component.exports